import { createContext } from 'react';

/**
 * Lets the deeply-nested copy step (`Review`) lock the enclosing bulk-copy modal
 * while a copy is running, so it cannot be closed (backdrop, ESC, or the header
 * close button) mid-copy — closing would abandon the not-yet-copied budgets.
 * The value is a setter the provider (`BudgetBulkCopy`) uses to track the lock;
 * default is a no-op so the context is safe to consume without a provider.
 */
export const BulkCopyLockContext = createContext<(locked: boolean) => void>(() => undefined);
